export default __webpack_public_path__ + "static/media/mark_headshot.2f805137.png";